import { t } from '@/i18n';
import { BackendBaseModel } from '@/utils';
import { z } from 'zod';

export const tagType = z.enum([
  'expenditure-cart',
  'comment',
  'workflow',
  'policy',
  'indicator',
  'fee',
  'carried-forward-request',
]);

export const tagScopeType = z.enum(['local', 'global']);

export const TagTypeLabelModifier = {
  'expenditure-cart': t('expenditure-cart'),
  comment: t('comment'),
  workflow: t('workflow'),
  policy: t('policy-system-tree'),
  indicator: t('indicator'),
  fee: t('fee-page'),
  'carried-forward-request': t('carried-forward-request'),
} as const satisfies Record<z.infer<typeof tagType>, string>;

export const TagBaseModel = BackendBaseModel.extend({
  type: tagType,
  name: z.string().min(1).max(16),
  scope: tagScopeType,
});

export const TagTargetBaseModel = z.object({
  objectId: z.string().uuid(),
  tagId: z.string().uuid(),
  tag: TagBaseModel,
});

export const TagsModel = TagBaseModel.extend({
  isTaggable: z.boolean(),
}).array();

export const TagListViewableSchema = z.object({
  startYear: z.number().int().positive().optional(),
  endYear: z.number().int().positive().optional(),
});
